export default {
  business: 'Für Ihr Unternehmen',
  'get-inspired': 'Inspiration',
  'how-to': "So Wird's Gemacht",
  news: 'News',
  printstories: 'Printstories',
  highlights: 'Highlights',
  'business-growth': 'Business growth',
}
